import { render, staticRenderFns } from "./Shopinfo.vue?vue&type=template&id=c98244c8&scoped=true&"
import script from "./Shopinfo.vue?vue&type=script&lang=js&"
export * from "./Shopinfo.vue?vue&type=script&lang=js&"
import style0 from "./Shopinfo.vue?vue&type=style&index=0&id=c98244c8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c98244c8",
  null
  
)

export default component.exports